// table.tsx

import { Table } from "../../../features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type S3Portfolio, porfolios_columns } from "./columns";
import { type FilterS3PortfoliosSchema, FilterS3Portfolios } from "./filter";

export const S3PortfoliosTable = () => {
  return (
    <Table<S3Portfolio, FilterS3PortfoliosSchema>
      label="Portfolios"
      client={Clients.S3}
      table_name={Tables.S3_PORTFOLIOS}
      columns={porfolios_columns}
      columnVisibilityInit={{}}
      filter={<FilterS3Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.S3}/${Tables.S3_PORTFOLIOS}/new`,
        },
      ]}
    />
  );
};
